import './App.css';
import SidingHome from "./components/sidingHome/sidingHome";

function App() {
  return (
    <div className="w-full h-auto m-0 p-0 box-border bg-bodyColor text-blackText">
      <SidingHome />
    </div>
  );
}

export default App;
